import React from 'react';
import PropTypes from 'prop-types';
import { pureRender } from 'epic-alt-utils/index';
import CallToAction from '../button/CallToAction';

@pureRender
class Tags extends React.Component {
    static propTypes = {
        legalTags: PropTypes.array,
        callToAction: PropTypes.object
    };

    render() {
        const legalTags = this.props.legalTags || [];
        const callToAction = this.props.callToAction || {};
        const hasLegalTags = legalTags && legalTags.length;
        const ctaEnabled = !hasLegalTags && callToAction;

        return (
            <div className={`${ctaEnabled ? 'cta-section' : 'col-xs-12 col-sm-4 col-md-5 col-lg-6'} tag-section`}>
                {hasLegalTags ? (
                    <ul className="tags">
                        {
                            legalTags.map((tag, i) => {
                                return (
                                    <li key={`legaltag-${tag.title}`}>
                                        <p className="tag-title accent-color">{tag.title}</p>
                                        <img alt="legal" src={tag.src} />
                                    </li>
                                );
                            })

                        }
                    </ul>
                ) : ''}
                {!hasLegalTags && callToAction ? (
                    <CallToAction callToAction={callToAction} />
                ) : ''}
            </div>
        );
    }
}

export default Tags;



// WEBPACK FOOTER //
// ./app/scripts/components/legal/Tags.js